import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-weavy.tsx
/**
* icon.24.logo.weavy
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkgMTRoMS41VjdoM3Y3SDE1VjdoM3Y3aC0ydjMuNWgtMy41VjE0aC0xdjMuNUg4VjE0SDZWN2gzeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=18068-8226
*/
const Icon24LogoWeavy = memo(function Icon24LogoWeavy(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M9 14h1.5V7h3v7H15V7h3v7h-2v3.5h-3.5V14h-1v3.5H8V14H6V7h3z"
		})
	});
});
//#endregion
export { Icon24LogoWeavy };

//# sourceMappingURL=icon-24-logo-weavy.js.map